import {
    takeLatest, all, put, call, select,
} from 'redux-saga/effects';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/ProductListOnDisplay';

function* getListProductOfComapy(action) {
    const endpoint = `/api/v1/company/${action.payload.company_id}/product/`;
    const resultsState = yield select((state) => state.productListOnDisplay.getList.data.results);
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                body: {
                    page: action.payload.page,
                    page_size: action.payload.page_size,
                    ...{ ...action.payload.language && { language: action.payload.language } },
                },
                token: credential.data?.token,
            },
        );
        let dataResult = {};
        if (resultsState) {
            dataResult = { ...response, results: [...resultsState, ...response.results] };
        } else {
            dataResult = response;
        }
        yield put(Actions.getProductListOnDisplayByCompanyReceived(dataResult));
    } catch (error) {
        yield put(Actions.getProductListOnDisplayByCompanyReceiveFailure(yield error));
    }
}

function* createBusinessContact(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post, {
                endpoint: '/api/v1/product/business_contact/',
                token: credential && credential.data.token,
                body: action.payload,
            },
        );
        yield put(Actions.createBusinessContactReceived(response));
    } catch (error) {
        yield put(Actions.createBusinessContactReceivedFailure(yield error));
    }
}

function* createAnonymousBusinessContact(action) {
    try {
        const response = yield call(
            API.post, {
                endpoint: '/api/v1/product/business_contact_anonymous/',
                body: action.payload,
            },
        );
        yield put(Actions.createAnonymousBusinessContactReceived(response));
    } catch (error) {
        yield put(Actions.createAnonymousBusinessContactReceivedFailure(yield error));
    }
}

function* sendExchangeBusinessCard(action) {
    try {
        const credential = yield select((state) => state.auth.credential);
        const response = yield call(
            API.post, {
                endpoint: `/api/v1/business_card/product/${action.payload.productId}/?language=${action.payload.language || 'ja'}`,
                token: credential && credential.data.token,
                body: action.payload.businessCardParams,
            },
        );
        yield put(Actions.exchangeBusinessCardReceived(response));
    } catch (error) {
        yield put(Actions.exchangeBusinessCardReceiveFailure(yield error));
    }
}

function* getExchangeBusinessCard() {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint: '/api/v1/business_card/viewer/',
                token: credential.data.token,
            },
        );
        yield put(Actions.GetExchangeBusinessCardReceived(response));
    } catch (error) {
        yield put(Actions.GetExchangeBusinessCardReceiveFailure(yield error));
    }
}

function* getUserProfile() {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint: '/api/v1/user/profile/',
                token: credential.data.token,
            },
        );
        yield put(Actions.getUserProfileReceived(response));
    } catch (error) {
        yield put(Actions.getUserProfileReceivedFailure(yield error));
    }
}

function* getCompanyIdsByEvent(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/event/${action.payload.shortName}/company_ids/?language=${action.payload.language}`
        : `/api/v1/event/${action.payload.shortName}/company_ids/`;
    try {
        const response = yield call(
            API.get, {
                endpoint,
                body: action.payload.queryParams,
            },
        );
        yield put(Actions.getCompanyIdsByEventReceived(response));
    } catch (error) {
        yield put(Actions.getCompanyIdsByEventReceivedFailure(yield error));
    }
}

function* addProductToCart(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post, {
                endpoint: '/api/v1/cart/',
                token: credential && credential.data.token,
                body: action.payload,
            },
        );
        yield put(Actions.addProductsToCartReceived(response));
    } catch (error) {
        yield put(Actions.addProductsToCartReceivedFailure(yield error));
    }
}

export default function* login() {
    yield all([
        takeLatest('GET_PRODUCT_LIST_DISPLAY_BY_COMPANY_REQUEST', getListProductOfComapy),
        takeLatest('CREATE_BUSINESS_CONTACT', createBusinessContact),
        takeLatest('CREATE_ANONYMOUS_BUSINESS_CONTACT', createAnonymousBusinessContact),
        takeLatest('EXCHANGE_BUSINESS_CARD_REQUESTED', sendExchangeBusinessCard),
        takeLatest('GET_EXCHANGE_BUSINESS_CARD_REQUESTED', getExchangeBusinessCard),
        takeLatest('GET_USER_PROFILE_REQUESTED', getUserProfile),
        takeLatest('GET_COMPANY_IDS_BY_EVENT_REQUESTED', getCompanyIdsByEvent),
        takeLatest('ADD_PRODUCT_TO_CART_REQUESTED', addProductToCart),
    ]);
}
